import React, { Component } from 'react';
import VerificationPending from '../../images/icons/not_verified.svg';
import VerificationRejected from '../../images/icons/verification_failed.svg';
import Verified from '../../images/icons/check.svg';
import { UserKycStatus } from '../../common/userData/UserKycStatus';
import { getBasicDetails } from '../../common/constants/api';
import NotInitiated from '../../images/icons/not_started.svg';
import Loading from '../../images/icons/loading2.svg';

class KYCHighlight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      partnerName: '',
      PartnerCode: '',
      pan_status: Loading,
      pan_message: '',
      address_proof_status: Loading,
      address_proof_message: '',
      selfie_status: Loading,
      selfie_message: '',
      bank_details_status: Loading,
      bank_details_message: '',
      reference_status: Loading,
      reference_message: '',
      loading: true
    };
  }

  componentWillMount() {
    this.state.loading
      ? (this.setState({ loading: false }),
        getBasicDetails()
          .then(data => {
            let first_name = data.name.firstName ? data.name.firstName : '';
            let middele_name = data.name.middleName ? data.name.middleName : '';
            let last_name = data.name.lastName ? data.name.lastName : '';
            this.setState({
              partnerName: first_name + ' ' + middele_name + ' ' + last_name,
              PartnerCode: data.partnerCode ? data.partnerCode : ''
            });
          })
          .catch(err => {}),
        UserKycStatus()
          .then(res => {
            let data = [
              { key: 'pan', value: res.pan },
              { key: 'address_proof', value: res.address },
              { key: 'selfie', value: res.selfie },
              { key: 'bank_details', value: res.bank },
              { key: 'reference', value: res.ref }
            ];

            let verification_status, verify_it, verification_message;
            for (let i = 0; i < data.length; i++) {
              verification_message = '';
              verification_status = '';
              try {
                verify_it = data[i]['value'];
              } catch {
                continue;
              }
              if (verify_it === 'NOT_INITIATED') {
                verification_status = NotInitiated;
                verification_message = 'Not Started';
              }
              if (verify_it === 'APPROVED') {
                verification_status = Verified;
              } else if (verify_it === 'PENDING') {
                verification_status = VerificationPending;
                verification_message = 'pending';
              } else if (verify_it === 'REJECTED') {
                verification_status = VerificationRejected;
                verification_message = 'rejected';
              }
              this.setState({
                [data[i]['key'] + '_status']: verification_status,
                [data[i]['key'] + '_message']: verification_message
              });
            }
          })
          .catch(e => {}))
      : null;
  }
  render() {
    var rows = [];
    let data = ['pan', 'address_proof', 'selfie', 'bank_details', 'reference'];
    let UiData = [
      'PAN',
      'Address Proof',
      'Selfie',
      'Bank Details',
      'Reference'
    ];

    for (var i = 0; i < 5; i++) {
      rows.push(
        <div className="w-9/12  md:w-8/12 ml-auto flex mt-10" key={data[i]}>
          <img className="w-4 mr-6 " src={this.state[data[i] + '_status']} />
          <p className="font-roboto font-noraml text-base w-3/12 lg:w-2/12  ">
            {UiData[i]}
          </p>
          {this.state[data[i] + '_message'] === 'pending' ? (
            <p className="w-3/12  md:w-4/12 lg:w-3/12 xl-w-2/12  text-xs font-roboto font-normal text-left pl-2 pr-5 py-1 bg-orange-600 rounded-lg mr-auto text-white mr-auto">
              {' '}
              Verification Pending
            </p>
          ) : null}
          {this.state[data[i] + '_message'] === 'rejected' ? (
            <p className="w-3/12  md:w-4/12 lg:w-3/12 xl-w-2/12  text-xs font-roboto font-normal text-left pl-2 pr-5 py-1 bg-red-200 rounded-lg mr-auto text-white mr-auto">
              {' '}
              Rejected/Upload Again
            </p>
          ) : null}
          {this.state[data[i] + '_message'] === 'Not Started' ? (
            <p className="w-3/12  md:w-4/12 lg:w-3/12 xl-w-2/12  text-xs font-roboto font-normal text-left pl-2 pr-5 py-1 bg-orange-600 rounded-lg mr-auto text-white mr-auto">
              {' '}
              Not Started
            </p>
          ) : null}
        </div>
      );
    }
    return (
      <div className="w-full mx-auto bg-white block ">
        <h1 className="font-roboto font-medium text-center text-black-0  text-3xl pt-24 pb-10">
          Welcome {this.state.partnerName}
        </h1>
        <p className="text-center font-base text-black-0 mt-6">
          Your Business Partner Code is{' '}
          <span className="px-3 py-1 border border-grey-980">
            {this.state.PartnerCode}
          </span>
        </p>
        <p className=" text-center font-sm  text-black-0 mt-16">
          Your KYC is completed Pending Following
        </p>
        <div className="w-full mx-auto ">{rows}</div>
        <div className="text-center w-full mt-10 ">
          <button
            type="submit"
            className="w-6/12 md:w-2/12 text-white py-2 text-lg font-khand font-semibold bg-green-800 rounded-lg mx-auto "
            // onClick={() => this.props.componentHandler(10)}
          >
            CONTINUE
          </button>
        </div>
      </div>
    );
  }
}

export default KYCHighlight;
